import React, { useEffect, useState } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import Profile from '../../components/profile';
import Notification from '../../components/Notification';
import Trolly from '../../components/Trolly';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import Alert from '../../components/Alert';
import LoadingScreen from '../../components/LoadingScreen';
import "../../css/saldo.css"

export default function IsiSaldo() {
 const [userData, setUser] = useState({})
 const [cookies, setCookie] = useCookies(['accessToken']);
 const [urlImg, setUrlImg] = React.useState('');
 const navigate = useNavigate();
 const [isLoading, setIsLoading] = useState(false);
 const [alertActive, setAlertActive] = useState(true);
 const [alert, setAlert] = useState({});
 const [saldo, setSaldo] = useState('');

 const activateAlert = () => {
  setAlertActive(true);
  setTimeout(() => {
   setAlertActive(false);
  }, 3000);
 };

 useEffect(() => {
  setUrlImg('/img/imageNull.png')
 }, []);

 const rupiah = (number) => {
  return new Intl.NumberFormat("id-ID", {
   style: "currency",
   currency: "IDR"
  }).format(number);
 }

 const handleUpdate = async () => {
  setIsLoading(true);
  try {
   if (saldo === '') { throw new Error('harap masukan nominal top up') }
   if (urlImg === '/img/imageNull.png') { throw new Error('harap masukan bukti transfer') }
   const url = 'https://w-shop-backend.vercel.app/api/users/';
   const response = await fetch(url, {
    method: 'PUT',
    headers: {
     'Content-type': 'application/json',
     'Authorization': 'Bearer ' + cookies.accessToken,
    },
    body: JSON.stringify({ saldo: parseInt(userData.saldo) + parseInt(saldo) }),
   });
   const body = await response.json();
   if (body.status !== 'success') {
    throw new Error(body.message,);
   } else {
    const event = {
     type: 'alert',
     alert: {
      type: 'success',
      message: 'Update Ticket Data Success',
     }
    };
    setCookie('event', event, { path: '/' });
    setAlert(event.alert)
    activateAlert()
    navigate('/home');
    setIsLoading(false)
   }
  } catch (error) {
   setIsLoading(false);
   setAlert({
    type: 'danger',
    message: 'Error: ' + error.message,
   })
   activateAlert();
  }
 }

 const UploadButtons =
  <>
   <Button variant="contained" component="label">
    Pilih Gambar <img alt="" src="/img/camera.png" className="ms-3" style={{ width: "30px" }}></img>
    <input hidden accept="image/*" type="file" onChange={(e) => {
     setUrlImg(URL.createObjectURL(e.target.files[0]))
    }} />
   </Button>
  </>
  
 return (
  <>
   <Navbar userData={setUser} logReg={<Profile userData={userData} />} notification={<Notification />} trolly={<Trolly />} />
   <>
    <LoadingScreen active={isLoading} />
    <Alert active={alertActive} type={alert.type} message={alert.message} />
    <div className=" container">
     <h1 className="titleWs mt-5 ms-2">W-ShopPay</h1>
     <div className="isi p-5 mb-5">
      <h3 className="subTitle">Saldo</h3>
      <div className="nom d-flex w-100 border-bottom mb-5">
       <img alt="" src="/img/iconMoney.png" className="imgMoney"></img>
       {rupiah(userData.saldo)}</div>
      <h3 className="subTitle">Jumlah Top Up</h3>
      <div className="nom d-flex w-100 border-bottom">
       Rp.<input type="number" className="w-100 border-0 nom ms-3" style={{ outline: "0" }} onChange={(e) => {
        setSaldo(e.target.value);
       }} />
      </div>
     </div>
    </div>
    <div className="bukti p-5">
     <div className="isiBukti container p-5">
      <h1 className="titleBukti">Masukan Bukti Transfer</h1>
      <div className="upload row">
       <div className="col-12 col-lg-4 imgProof">
        <img alt="" src={urlImg} style={{ width: "100%", height: "100%" }} />
       </div>
       <div className="col-12 col-lg-8 pt-5">
        {UploadButtons}
        <h6 className="pil mt-5">Ukuran gambar : maks 1 mb</h6>
        <h6 className="pil ">Format gambar : JPG, PNG</h6>
        <button className="btn btn-primary  ms-auto  d-block" style={{ width: '180px', marginTop: '15%', height: '50px' }} onClick={handleUpdate}>Simpan</button>
       </div>
      </div>
     </div>
    </div>
   </>
   <Footer />
  </>
 );
}
